// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__nd-uy","slideIn":"Toast_slideIn__i776H","success":"Toast_success__BTuS8","warning":"Toast_warning__gUheG"};